import React, { Component } from 'react';
import classNames from 'classnames';

import { Divider } from '@eventbrite/eds-divider';

import ImageContainer from './ImageContainer';
import PrimaryContent from './PrimaryContent';
import SubContent from './SubContent';
import EventCardActions from './EventCardActions';
import Flag from './Flag';
import { PromotedLabel } from '../PromotedLabel';

import { LIST_TYPE, EVENT_CARD_PROPTYPES } from './constants';

import './listEventCardContent.scss';

const DividerComponent = ({ shouldShowDivider }) => {
    let component = null;

    if (shouldShowDivider) {
        component = (
            <div className="eds-event-card-content__divisor eds-l-pad-vert-4">
                <Divider color="ui-orange" />
            </div>
        );
    }

    return component;
};

const ListEventCardContentContainer = ({
    title,
    subtitle,
    description,
    onClick,
    linkUrl,
    linkAlt,
    style,
    shouldShowDivider,
    subContentOne,
    subContentTwo,
    subContentThree,
    subContentFour,
    secondaryIconType,
    isTargetBlank,
    isNoFollow,
    useSmallPadding,
    isPromoted,
    bucketLabel,
    bucketKey,
}) => (
    <div
        className={classNames(
            'eds-event-card-content__content-container',
            {
                'eds-event-card-content__content-container--small-padding':
                    useSmallPadding,
            },
            'eds-l-pad-right-4',
        )}
    >
        <div className="eds-event-card-content__content">
            {isPromoted && <PromotedLabel />}
            <div
                className="eds-event-card-content__content__principal"
                data-event-bucket-label={bucketLabel}
                data-event-bucket-key={bucketKey}
            >
                <PrimaryContent
                    title={title}
                    subtitle={subtitle}
                    description={description}
                    onClick={onClick}
                    linkUrl={linkUrl}
                    linkAlt={linkAlt}
                    isTargetBlank={isTargetBlank}
                    isNoFollow={isNoFollow}
                    style={style}
                    type={LIST_TYPE}
                />
                <DividerComponent shouldShowDivider={shouldShowDivider} />

                <SubContent
                    subContentOne={subContentOne}
                    subContentTwo={subContentTwo}
                    subContentThree={subContentThree}
                    subContentFour={subContentFour}
                    hasTwoActionButtons={secondaryIconType}
                />
            </div>
        </div>
    </div>
);

export default class ListEventCardContent extends Component {
    static propTypes = {
        ...EVENT_CARD_PROPTYPES,
    };

    render() {
        const {
            id,
            style,
            imageStyle,
            imageUrl,
            isLazyImage,
            imageAlt,
            shouldHideImage,
            placeholderBgColor,
            onClick,
            onFocus,
            onBlur,
            linkUrl,
            title,
            subtitle,
            description,
            flag,
            flagDark,
            shouldShowDivider,
            subContentOne,
            subContentTwo,
            subContentThree,
            subContentFour,
            primaryIconType,
            primaryIconStyle,
            primaryIconTitle,
            primaryIconOnClick,
            secondaryIconType,
            secondaryIconStyle,
            secondaryIconTitle,
            secondaryIconOnClick,
            shouldShowIcons,
            containerSpacingClasses,
            isTargetBlank,
            isNoFollow,
            isPromoted,
            focused,
            useSmallPadding,
            showLikesTooltip,
            saved,
            showRemoveTooltip,
            showMoreActions,
            onEventCardMoreAction,
            bucketLabel,
            bucketKey,
        } = this.props;

        const classes = classNames(
            containerSpacingClasses,
            'eds-event-card-content',
            'eds-event-card-content--list',
            `eds-event-card-content--${style}`,
            `eds-event-card-content--${imageStyle}`,
            {
                'eds-event-card-content--focused': focused,
            },
        );

        let imageContainer = null;

        if (!shouldHideImage) {
            imageContainer = (
                <div className="image-action-container">
                    <ImageContainer
                        onClick={onClick}
                        linkUrl={linkUrl}
                        imageUrl={imageUrl}
                        isLazyImage={isLazyImage}
                        imageAlt={imageAlt}
                        imageStyle={imageStyle}
                        flag={flag}
                        flagDark={flagDark}
                        style={style}
                        placeholderBgColor={placeholderBgColor}
                        isTargetBlank={isTargetBlank}
                        isNoFollow={isNoFollow}
                    />
                    <EventCardActions
                        id={id}
                        primaryIconType={primaryIconType}
                        primaryIconStyle={primaryIconStyle}
                        primaryIconTitle={primaryIconTitle}
                        primaryIconOnClick={primaryIconOnClick}
                        secondaryIconType={secondaryIconType}
                        secondaryIconStyle={secondaryIconStyle}
                        secondaryIconTitle={secondaryIconTitle}
                        secondaryIconOnClick={secondaryIconOnClick}
                        shouldShowIcons={shouldShowIcons}
                        isListCard={true}
                        showLikesTooltip={showLikesTooltip}
                        saved={saved}
                        showRemoveTooltip={showRemoveTooltip}
                        showMoreActions={showMoreActions}
                        onEventCardMoreAction={onEventCardMoreAction}
                    />
                </div>
            );
        }

        return (
            <article
                className={classes}
                onFocus={onFocus}
                onBlur={onBlur}
                role="presentation"
            >
                <ListEventCardContentContainer
                    title={title}
                    subtitle={subtitle}
                    description={description}
                    onClick={onClick}
                    linkUrl={linkUrl}
                    linkAlt={imageAlt}
                    isPromoted={isPromoted}
                    isTargetBlank={isTargetBlank}
                    isNoFollow={isNoFollow}
                    style={style}
                    shouldShowDivider={shouldShowDivider}
                    subContentOne={subContentOne}
                    subContentTwo={subContentTwo}
                    subContentThree={subContentThree}
                    subContentFour={subContentFour}
                    primaryIconType={primaryIconType}
                    primaryIconStyle={primaryIconStyle}
                    primaryIconTitle={primaryIconTitle}
                    primaryIconOnClick={primaryIconOnClick}
                    secondaryIconType={secondaryIconType}
                    secondaryIconStyle={secondaryIconStyle}
                    secondaryIconTitle={secondaryIconTitle}
                    secondaryIconOnClick={secondaryIconOnClick}
                    shouldShowIcons={shouldShowIcons}
                    useSmallPadding={useSmallPadding}
                    bucketLabel={bucketLabel}
                    bucketKey={bucketKey}
                />
                {imageContainer}
                <Flag flag={flag} flagDark={flagDark} />
            </article>
        );
    }
}
